




















































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addPlayer, queryPlayerById, updatePlayer } from '@/api/player.ts'
import { UserModule } from '@/store/modules/user'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private title = '新增选手';
  private title1 = '';
  private imageUrl: string = ''
  private actionType: string = 'add'
  private vueRest = '1'
  private index = 0
  private inputStyle = { flex: 1 }
  private titleId = ''
  private titleId1 = ''
  private addType = 0
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    photo: '',
    name: '',
    number:0,
    hot: 0,
    addHot: 0,
  }

  get rules() {
    return {
      photo: {
        required: true,
        message: '选手照片不能为空'
      },
      name: {
        required: true,
        message: '选手姓名不能为空'
      }
    }
  }

  created() {
    this.titleId1 = this.$route.query.titleId;
    if (this.$route.query.title) {
      this.title1 = this.$route.query.title
    }
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改选手信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  changeAddType(number: number) {
    if (number == 0) {
      document.getElementById('add')!.style.backgroundColor = "#ffc200"
      document.getElementById('reduce')!.style.backgroundColor = "#f0f0f0"
      this.addType = 0
    } else {
      document.getElementById('reduce')!.style.backgroundColor = "#ffc200"
      document.getElementById('add')!.style.backgroundColor = "#f0f0f0"
      this.addType = 1
    }
  }

  cancel() {
    this.$router.push({ path: '/playerManage', query: { titleId: this.titleId1, title: this.title1 } })
  }

  // 判断是否有权限
  private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin')) return true;
    return false;
  }

  private async init() {
    queryPlayerById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.imageUrl = res.data.data.photo
        this.ruleForm = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.photo) return this.$message.error('选手照片不能为空')
        if (!this.ruleForm.name) return this.$message.error('选手姓名不能为空')
        // let params: any = { ...this.ruleForm }
        let params: any = {}
        // params.flavors = this.dishFlavors
        params.photo = this.ruleForm.photo
        params.name = this.ruleForm.name
        params.type = 1
        // params.price *= 100
        if (this.actionType == 'add') {
          params.titleId = this.titleId
          delete params.id
          addPlayer(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('选手新增成功！')
                  this.$router.push({ path: '/playerManage', query: { titleId: this.titleId1, title: this.title1 } })
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          params.number = this.ruleForm.number
          params.hot = this.ruleForm.hot
          params.addType = this.addType
          if (this.ruleForm.addHot == null) {
            params.addHot = 0
          } else {
            params.addHot = this.ruleForm.addHot
          }
          params.titleId = this.titleId
          params.type = 1
          updatePlayer(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$router.push({ path: '/playerManage', query: { titleId: this.titleId1, title: this.title1 } })
                this.$message.success('选手信息修改成功！')
              } else {
                this.$message.error(res.data.desc || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.photo = value
  }
}
